export const USER_REQUEST_CONFIG = {
  output: {
    level: "private",
    contentType: "application/octet-stream",
    customPrefix: { private: "Output/" }
  },
  input: {
    level: "private",
    contentType: "application/octet-stream",
    customPrefix: { private: "Input/" },
    expires: 9600
  },
  db: {
    level: "private",
    contentType: "application/json",
    customPrefix: { private: "Input/" },
    expires: 9600
  },
  dbDownload: {
    level: "private",
    contentType: "application/json",
    customPrefix: { private: "Input/" },
    download: true,
    expires: 9600
  },
  footprintDownload: {
    level: "private",
    contentType: "image/png",
    customPrefix: { private: "Output/" },
    download: true,
    expires: 9600
  },
  footprint: {
    level: "private",
    contentType: "image/png",
    customPrefix: { private: "Output/" },
    expires: 9600
  },
  outputJsonDownload: {
    level: "private",
    contentType: "application/json",
    customPrefix: { private: "Output/" },
    expires: 9600,
    download: true
  }


};

export const PUBLIC_REQUEST_CONFIG = {
  input: {
    level: "public",
    contentType: "application/octet-stream",
    customPrefix: { public: "Public/" },
    expires: 9600
  },
  db: {
    level: "public",
    contentType: "application/json",
    customPrefix: { public: "Public/" },
    expires: 9600
  },
  dbDownload: {
    level: "public",
    contentType: "application/json",
    customPrefix: { public: "Public/" },
    download: true,
    expires: 9600
  },
}

export const USER_PATH_CONFIG = {
  assetBundleMeta: "assetBundle/ios/model.meta",
  webglAssetBundleMeta: "assetBundle/webgl/model.meta",
  webglAssetBundle: "assetBundle/webgl/model",
  footprint: "footprint/footprint.png",
  modelInfo: "modelInfo.json",
  unityStatus: "unityStatus.json",
  db: "db.json"
};


export const PUBLIC_PATH_CONFIG = {
  db: "db.json"
};
export const MAX_MODEL_FILE_SIZE = 600 * 1024 * 1024;
export const MODEL_FILE_EXT_REGX = /\.(fbx|obj|skp|ifc|rvt|3dm|dxf|dwg|dae|sldprt|glt|gltf|rar|zip|zipx|7z|tar.gz|tar.bz2|max|blender)$/gi;
export const MATERIAL_FILE_EXT_REGX = /\.(mtl)$/gi;
export const FILE_SANITATION_REGX = /[\W]+/g;
export const SUPORTED_MODEL_EXT = ".fbx,.obj,.skp,.ifc,.rvt,.3dm,.dxf,.dwg,.dae,.sldprt,.glt,.gltf,.rar,.zip,.zipx,.7z,.tar.gz,.tar.bz2,.max,.blender";
export const WHITE_SPACE_RATIO = 1.41421;


export const AWS_CONFIG = {
  Auth: {
    identityPoolId: "eu-central-1:6d749829-62f6-4b82-97d1-22caca1f8eab",
    region: "eu-central-1",
    identityPoolRegion: "eu-central-1",
    userPoolId: "eu-central-1_panfTs9Sn",
    userPoolWebClientId: "234dtmirter666u23h57kk8q4g",
    mandatorySignIn: true
  },
  Storage: {
    bucket: "cviker-models", //REQUIRED -  Amazon S3 bucket
    region: "eu-central-1" //OPTIONAL -  Amazon service region
  }
};


export const AWS_CONFIG_PUBLIC = {
  Auth: {
    identityPoolId: "eu-central-1:6d749829-62f6-4b82-97d1-22caca1f8eab",
    region: "eu-central-1",
    identityPoolRegion: "eu-central-1",
    userPoolId: "eu-central-1_panfTs9Sn",
    userPoolWebClientId: "2gdpuk006m9st6uhgpd1gtaunl",
    mandatorySignIn: false
  },
  Storage: {
    bucket: "cviker-models-public", //REQUIRED -  Amazon S3 bucket
    region: "eu-central-1" //OPTIONAL -  Amazon service region
  }
};

export const GOOGLE_MAPS_CONFIG = {
  KEY: "AIzaSyADQD2eyhoX5o-mRh-UZnGAwWMzEOPBnjk",//new api key from matej.klobusnik@cvikerar.com free tier
  LANGUAGE: "en",
  REGION: "GB",
  LIBRARIES: ["places"]
};


export const MUI_STYLES = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,

  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20
  },
  details: {
    alignItems: "center"
  },
  column: {
    flexBasis: "33.33%"
  },
  wideColumn: {
    flexBasis: "100%"
  },
  mapWrapper: {
    height: 300,
    width: "80%",
    backgroundColor: "grey",
    margin: "auto"
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});